var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43082 1.58261L11.215 3.36675H4.53635C2.38858 3.36675 0.647461 5.10786 0.647461 7.25564V9.58897H2.20302V7.25564C2.20302 5.96697 3.24769 4.9223 4.53635 4.9223H11.2134L9.43082 6.70489L10.5308 7.80483L14.1919 4.14375L10.5308 0.482666L9.43082 1.58261ZM5.86422 16.0382L4.08086 14.2548H10.7587C12.9065 14.2548 14.6476 12.5137 14.6476 10.3659V8.0326H13.092V10.3659C13.092 11.6546 12.0474 12.6993 10.7587 12.6993H4.08086L5.86422 10.9159L4.76427 9.81596L1.10319 13.477L4.76427 17.1381L5.86422 16.0382Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchIcon);
export default __webpack_public_path__ + "static/media/switch_icon.0bbf83af54c51355084225e9b125e231.svg";
export { ForwardRef as ReactComponent };